import detectComplexNumber from "./detectComplexNumber"

export default (arrayBarcodes) => {
    const listBarcode = arrayBarcodes.map(barcode => {
        const complexPre = detectComplexNumber('#' + barcode)

        if (complexPre) {
            const {index, number} = complexPre

            if (!number || !index) {
                return false
            }

            if (typeof number === 'undefined') {
                return false
            }

            return number
        }

        return false
    })

    const newList = Array.from(new Set(listBarcode))

    if (newList.length > 1) {
        return false
    }

    return newList
}
